<template>
    <div style="min-width: 80vw">
        <v-tabs
            v-model="tabStep"
            fixed-tabs
            style="background-color: transparent !important; border-radius: 16px; overflow: hidden"
        >
            <v-tab value="tagTab"><strong>Etiquettes</strong></v-tab>
            <v-tab value="logTab"><strong>Journaux</strong></v-tab>
            <v-tab value="accessRightTab"><strong>Cellule</strong></v-tab>
        </v-tabs>

        <v-tabs-window v-model="tabStep">
            <v-window-item key="tagTab" value="tagTab">
                <v-row no-gutters class="pb-2">
                    <v-col cols="5" class="mt-2 d-flex justify-start">
                        <v-row no-gutters v-if="viewMode === 1">
                            <v-col class="mb-2">
                                <v-btn size="small" @click="selectAllTags()">
                                    Sélectionner tout
                                </v-btn>
                            </v-col>
                            <v-col class="mb-2 pl-2">
                                <v-btn size="small" @click="diselectAllTags()">
                                    Désélectionner tout
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3">
                        <v-select-filled
                            v-if="viewMode === 1"
                            v-model="selectedTagType"
                            :items="tagTypes"
                            class="mt-2"
                            hide-details
                            label="Filtrer par type"
                            density="compact"
                            :item-title="(item) => item.text"
                        />
                    </v-col>
                    <v-col cols="4" class="d-flex justify-end">
                        <v-tooltip v-if="viewMode === 1 && hasTagDistribution" location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    class="mr-2"
                                    @click="mergeSelectedTags"
                                    v-bind="props"
                                    :disabled="true"
                                    size="small"
                                >
                                    Fusionner
                                </v-btn>
                            </template>
                            <span
                                >La fusion est impossible avec un tag de type TagDistribution.</span
                            >
                        </v-tooltip>
                        <v-btn
                            v-if="viewMode === 1 && !hasTagDistribution"
                            class="mr-2"
                            @click="mergeSelectedTags"
                            :disabled="mergeDisabled"
                            size="small"
                        >
                            Fusionner
                        </v-btn>
                        <v-btn
                            v-if="viewMode === 1"
                            elevation="0"
                            class="mr-2"
                            rounded
                            @click="deleteSelectedTags()"
                            :disabled="!selectedTags.length"
                            size="small"
                        >
                            Supprimer
                        </v-btn>
                        <v-btn-toggle v-model="viewMode" mandatory density="compact" rounded="xl">
                            <v-btn-icon :value="0" icon="$fa-columns"></v-btn-icon>
                            <v-btn-icon :value="1" icon="$fa-th-list"></v-btn-icon>
                        </v-btn-toggle>
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col cols="12">
                        <v-window v-model="viewMode">
                            <v-window-item :value="0">
                                <v-row no-gutters>
                                    <v-col cols="6" class="pa-2">
                                        <v-row
                                            no-gutters
                                            style="border-radius: 12px; background: #f8f8f8"
                                            class="pa-2 mb-2 elevation-0"
                                            v-if="unclassedPartitionTag && !accountingFirmId"
                                        >
                                            <v-col cols="7" class="title d-flex">
                                                {{ unclassedPartitionTag.name }}
                                            </v-col>
                                            <v-col cols="12" class="my-3">
                                                <draggable
                                                    :id="unclassedPartitionTag.id"
                                                    :list="unclassedPartitionTag.tags"
                                                    class="list-group"
                                                    draggable=".item"
                                                    group="a"
                                                    @change="
                                                        updateTag($event, unclassedPartitionTag.id)
                                                    "
                                                >
                                                    <template #item="{ element: tag }">
                                                        <div
                                                            class="list-group-item item px-2 py-1 mr-2 mt-1 d-flex"
                                                            style="
                                                                width: fit-content !important;
                                                                float: left;
                                                            "
                                                            :key="tag.id"
                                                            @click.stop="editTag(tag)"
                                                        >
                                                            <span>{{ tag.name }}</span>
                                                            <div class="pl-2">
                                                                <v-icon
                                                                    dense
                                                                    @click.stop="
                                                                        checkDeleteTag(tag.id)
                                                                    "
                                                                    size="x-small"
                                                                    >$oss-trash</v-icon
                                                                >
                                                            </div>
                                                        </div>
                                                    </template>
                                                </draggable>
                                            </v-col>
                                            <v-col cols="12" class="d-flex align-center pt-3">
                                                <v-text-field
                                                    v-model="newTags[unclassedPartitionTag.key]"
                                                    append-inner-icon="$add"
                                                    label="Nom du nouveau tag"
                                                    color="primary"
                                                    outlined
                                                    hide-details
                                                    density="compact"
                                                    @click:append-inner="
                                                        createTag(unclassedPartitionTag)
                                                    "
                                                />
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            no-gutters
                                            class="pa-2 my-2 elevation-0"
                                            style="border-radius: 12px; background: #f8f8f8"
                                        >
                                            <v-col cols="10" class="pr-2 d-flex align-center">
                                                <v-text-field
                                                    v-model="partitionName"
                                                    outlined
                                                    label="Nom de la partition"
                                                    hide-details
                                                    density="compact"
                                                />
                                            </v-col>
                                            <v-col cols="2" class="d-flex align-center">
                                                <v-btn
                                                    rounded
                                                    elevation="0"
                                                    :disabled="!partitionName"
                                                    @click="createPartitionTag()"
                                                    size="small"
                                                    >Créer</v-btn
                                                >
                                            </v-col>
                                            <!-- <v-col v-if="accountingFirmId" cols="12" class="mt-2 mb-2">
                                            <span class="title">Périmètre</span>
                                        </v-col>
                                        <v-col v-if="accountingFirmId" cols="12" class="d-flex align-center">
                                            <Scope
                                                ref="refScope"
                                                v-model="scopeSync"
                                                v-model:id="scopeId"
                                            ></Scope>
                                        </v-col> -->
                                        </v-row>
                                        <v-row no-gutters v-if="scopingPartitionTags.length">
                                            <v-divider />
                                            <v-col cols="12" class="mt-2">
                                                <span class="title">Partitions de mon cabinet</span>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                class="mt-2"
                                                v-for="(partition, index) in scopingPartitionTags"
                                                :key="index"
                                            >
                                                <v-row
                                                    no-gutters
                                                    class="pa-2 my-2 elevation-0"
                                                    style="border-radius: 12px; background: #f8f8f8"
                                                >
                                                    <v-col
                                                        cols="9"
                                                        class="pr-2 d-flex align-center"
                                                    >
                                                        {{ partition.name }}
                                                    </v-col>
                                                    <v-col
                                                        cols="3"
                                                        class="d-flex align-right justify-end"
                                                    >
                                                        <v-btn
                                                            rounded
                                                            elevation="0"
                                                            @click="
                                                                duplicatePartitionAccountingFirm(
                                                                    partition,
                                                                )
                                                            "
                                                            v-if="
                                                                partition &&
                                                                partition.id !== 'WithoutId'
                                                            "
                                                            :disabled="
                                                                isPartitionUsed(partition.id)
                                                            "
                                                            size="small"
                                                            block
                                                        >
                                                            Appliquer
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" class="my-3">
                                                        <div
                                                            class="list-group-item item px-2 py-1 mr-2 mt-1 d-flex"
                                                            v-for="tag in partition.tags"
                                                            style="
                                                                width: fit-content !important;
                                                                float: left;
                                                            "
                                                            :key="tag.id"
                                                        >
                                                            <!-- @click.stop="editTag(tag)" -->
                                                            <div
                                                                class="pr-2"
                                                                v-if="partition.type === 'Building'"
                                                            >
                                                                <v-icon dense size="x-small"
                                                                    >$fa-building</v-icon
                                                                >
                                                            </div>
                                                            <span>{{ tag.name }}</span>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6" class="pa-2">
                                        <v-row no-gutters>
                                            <v-col
                                                cols="12"
                                                v-for="(partition, index) in classedPartitionTags"
                                                :key="index"
                                            >
                                                <v-row
                                                    no-gutters
                                                    style="border-radius: 12px; background: #f8f8f8"
                                                    class="mb-2 pa-2 elevation-0"
                                                >
                                                    <v-col cols="8" class="title d-flex">
                                                        {{ partition.name }}
                                                        <v-tooltip
                                                            v-if="
                                                                partition.id !== 'WithoutId' &&
                                                                !partition.primaryLog
                                                            "
                                                            location="bottom"
                                                        >
                                                            <template v-slot:activator="{ props }">
                                                                <v-btn-icon
                                                                    icon="$oss-edit"
                                                                    v-bind="props"
                                                                    color="primary"
                                                                    class="ml-2"
                                                                    @click="
                                                                        editPartition(partition)
                                                                    "
                                                                    size="small"
                                                                />
                                                            </template>
                                                            <span>Editer la partition</span>
                                                        </v-tooltip>
                                                        <v-tooltip
                                                            v-if="
                                                                partition.id !== 'WithoutId' &&
                                                                !partition.primaryLog &&
                                                                !disabledDeleteTag(partition)
                                                            "
                                                            location="bottom"
                                                        >
                                                            <template v-slot:activator="{ props }">
                                                                <v-btn-icon
                                                                    icon="$oss-trash"
                                                                    v-bind="props"
                                                                    color="primary"
                                                                    class="ml-2"
                                                                    @click="
                                                                        deletePartition(
                                                                            partition.id,
                                                                        )
                                                                    "
                                                                    size="small"
                                                                />
                                                            </template>
                                                            <span>Supprimer la partition</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col
                                                        cols="4"
                                                        class="d-flex align-center justify-end"
                                                    >
                                                        <v-btn
                                                            rounded
                                                            class="ml-2"
                                                            elevation="0"
                                                            @click="
                                                                openNewTagDistributionDialog(
                                                                    partition,
                                                                )
                                                            "
                                                            v-if="
                                                                partition &&
                                                                partition.id !== 'WithoutId' &&
                                                                !partition.primaryLog
                                                            "
                                                            size="small"
                                                        >
                                                            Ajouter une Distribution
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col v-if="partition.companyScope" cols="12">
                                                        <div>
                                                            <v-icon x-small class="mr-2"
                                                                >$fa-bullseye</v-icon
                                                            >{{
                                                                getTargets(partition.companyScope)
                                                            }}
                                                        </div>
                                                        <div>
                                                            <span
                                                                v-if="
                                                                    partition.companyScope &&
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner &&
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner
                                                                        .name &&
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner
                                                                        .name !== 'OSS360'
                                                                "
                                                            >
                                                                {{
                                                                    "Créée par " +
                                                                    partition.companyScope
                                                                        .accountingCompanyOwner.name
                                                                }}
                                                            </span>
                                                            <span v-else> Créée par bobbee </span>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12" class="my-3">
                                                        <draggable
                                                            :id="partition.id"
                                                            :list="partition.tags"
                                                            class="list-group"
                                                            draggable=".item"
                                                            group="a"
                                                            @change="
                                                                updateTag($event, partition.id)
                                                            "
                                                        >
                                                            <template #item="{ element: tag }">
                                                                <div
                                                                    class="list-group-item item px-2 py-1 mr-2 mt-1 d-flex"
                                                                    style="
                                                                        width: fit-content !important;
                                                                        float: left;
                                                                    "
                                                                    :key="tag.id"
                                                                    @click.stop="editTag(tag)"
                                                                >
                                                                    <div
                                                                        class="pr-2"
                                                                        v-if="
                                                                            partition.type ===
                                                                            'Building'
                                                                        "
                                                                    >
                                                                        <v-icon dense size="x-small"
                                                                            >$fa-building</v-icon
                                                                        >
                                                                    </div>
                                                                    <span>{{ tag.name }}</span>
                                                                    <div
                                                                        class="pl-2"
                                                                        v-if="
                                                                            !disabledDeleteTag(
                                                                                partition,
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            dense
                                                                            @click.stop="
                                                                                checkDeleteTag(
                                                                                    tag.id,
                                                                                )
                                                                            "
                                                                            size="x-small"
                                                                            >$oss-trash</v-icon
                                                                        >
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </draggable>
                                                    </v-col>
                                                    <v-col
                                                        cols="12"
                                                        class="d-flex align-center pt-3"
                                                    >
                                                        <v-text-field
                                                            v-model="newTags[partition.key]"
                                                            append-inner-icon="$add"
                                                            label="Nom du nouveau tag"
                                                            color="primary"
                                                            outlined
                                                            hide-details
                                                            density="compact"
                                                            @click:append-inner="
                                                                createTag(partition)
                                                            "
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <!-- <v-row no-gutters v-else>
                                <v-col cols="12" class="pa-2" v-for="(partition, index) in classedPartitionTags" :key="index">
                                    <v-row no-gutters style="border-radius: 12px; background: #F8F8F8" class="my-2 pa-2 elevation-1">
                                        <v-col cols="8" class="title d-flex">
                                            {{ partition.name }}
                                            <v-tooltip bottom v-if="partition.id !== 'WithoutId' && !partition.primaryLog">
                                                <template v-slot:activator="{ props }">
                                                    <v-btn
                                                        v-bind="props"
                                                        icon
                                                        size="small"
                                                        color="primary"
                                                        class="ml-2"
                                                        @click="editPartition(partition)"
                                                    >
                                                        <v-icon color="primary"  size="small">
                                                            $oss-edit
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Editer la partition</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="partition.id !== 'WithoutId' && !partition.primaryLog && !disabledDeleteTag(partition)">
                                                <template v-slot:activator="{ props }">
                                                    <v-btn
                                                        v-bind="props"
                                                        icon
                                                        size="small"
                                                        color="primary"
                                                        class="ml-2"
                                                        @click="deletePartition(partition.id)"
                                                    >
                                                        <v-icon color="primary"  size="small">
                                                            $oss-trash
                                                        </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Supprimer la partition</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="4" class="d-flex align-center justify-end">
                                            <v-btn
                                                size="small"
                                                color="primary"
                                                rounded
                                                class="ml-2"
                                                elevation="0"
                                                @click="openNewTagDistributionDialog(partition)"
                                                v-if="partition && partition.id !== 'WithoutId' && !partition.primaryLog"
                                            >
                                                Ajouter une Distribution
                                            </v-btn>
                                        </v-col>
                                        <v-col v-if="partition.companyScope" cols="12">
                                            <div><v-icon  size=“x-small” class="mr-2">$fa-bullseye</v-icon>{{ getTargets(partition.companyScope) }}</div>
                                            <div>
                                                <span v-if="partition.companyScope && partition.companyScope.accountingCompanyOwner && partition.companyScope.accountingCompanyOwner.name && partition.companyScope.accountingCompanyOwner.name !== 'OSS360'">
                                                    {{'Créée par ' + partition.companyScope.accountingCompanyOwner.name}}
                                                </span>
                                                <span v-else>
                                                    Créée par bobbee
                                                </span>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" class="my-3">
                                            <draggable
                                                :id="partition.id"
                                                :list="partition.tags"
                                                class="list-group"
                                                draggable=".item"
                                                group="a"
                                                @change="updateTag($event, partition.id)"
                                            >
                                                <div
                                                    class="list-group-item item px-2 py-1 mr-2 mt-1 d-flex"
                                                    v-for="tag in partition.tags"
                                                    style="width: fit-content !important; float: left"
                                                    :key="tag.id"
                                                    @click.stop="editTag(tag)"
                                                >
                                                    <div class="pr-2" v-if="partition.type==='Building'">
                                                        <v-icon
                                                            dense
                                                            size=“x-small”
                                                        >$fa-building</v-icon>
                                                    </div>
                                                    <span>{{ tag.name }}</span>
                                                    <div class="pl-2" v-if="!disabledDeleteTag(partition)">
                                                        <v-icon
                                                            dense
                                                            size=“x-small”
                                                            @click.stop="checkDeleteTag(tag.id, partition.id, index)"
                                                        >$oss-trash</v-icon>
                                                    </div>
                                                </div>
                                            </draggable>
                                        </v-col>
                                        <v-col cols="12" class="d-flex align-center pt-3">
                                            <v-text-field
                                                v-model="newTags[partition.key]"
                                                append-inner-icon="$add"
                                                label="Nom du nouveau tag"
                                                color="primary"
                                                @click:append-inner="createTag(partition)"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <Scope
                                    ref="refScope"
                                    v-model="scopeSync"
                                    v-model:id="scopeId"
                                ></Scope>
                            </v-row> -->
                            </v-window-item>
                            <v-window-item :value="1">
                                <v-row no-gutters class="py-2">
                                    <v-col
                                        cols="12"
                                        style="overflow-y: auto; height: calc(100vh - 205px)"
                                    >
                                        <v-list subheader density="compact" lines="two">
                                            <template v-if="!tags.length">
                                                <v-list-item
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    "
                                                >
                                                    <v-list-item-title>
                                                        Aucun tag n'a été trouvé
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </template>
                                            <template v-for="(tag, i) in filteredTags">
                                                <v-list-item
                                                    :key="i + tag.id"
                                                    :class="
                                                        !$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    "
                                                    v-if="!tag.primaryLog"
                                                >
                                                    <v-list-item-title>
                                                        {{ tag.name }}
                                                    </v-list-item-title>
                                                    <template v-slot:prepend>
                                                        <v-checkbox
                                                            v-model="selectedTags"
                                                            :key="i + tag.id"
                                                            class="pa-0 ma-0"
                                                            @click.stop="selectTag(tag)"
                                                            :value="isSelectedTag(tag)"
                                                        />
                                                    </template>

                                                    <template
                                                        v-slot:append
                                                        class="d-flex align-center"
                                                        style="width: 220px"
                                                    >
                                                        <v-select-filled
                                                            v-model="tag.partitionTag"
                                                            :items="partitionTags"
                                                            outlined
                                                            hide-details
                                                            label="Partition"
                                                            item-value="id"
                                                            @update:model-value="
                                                                updateTag(tag, $event)
                                                            "
                                                            density="compact"
                                                            :item-title="(item) => item.name"
                                                        />
                                                    </template>
                                                </v-list-item>
                                            </template>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                        </v-window>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="logTab">
                <v-row no-gutters class="justify-center">
                    <v-col cols="8" class="pa-2" v-for="(partition, index) in logs" :key="index">
                        <v-row
                            no-gutters
                            style="border-radius: 12px; background: #f8f8f8"
                            class="pa-2 fill-height"
                        >
                            <v-col cols="8" class="title d-flex">
                                {{ partition.name }}
                            </v-col>
                            <v-col cols="4" class="d-flex align-center justify-end">
                                <v-text-field
                                    v-model="newTags[partition.key]"
                                    append-inner-icon="$add"
                                    label="Nom du nouveau journal"
                                    color="primary"
                                    @click:append-inner="createTag(partition)"
                                    outlined
                                    dense
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="12" class="my-3">
                                <div
                                    class="logItem px-2 py-1 mr-2 mt-1 d-flex"
                                    v-for="tag in partition.tags"
                                    style="width: fit-content !important; float: left"
                                    :key="tag.id"
                                    @click.stop="editTag(tag)"
                                >
                                    <div class="pr-2" v-if="partition.type === 'Building'">
                                        <v-icon dense size="&#x201c;x-small&#x201d;"
                                            >$fa-building</v-icon
                                        >
                                    </div>
                                    <span>{{ tag.name }}</span>
                                    <div class="pl-2" v-if="!disabledDeleteTag(partition)">
                                        <v-icon
                                            dense
                                            size="&#x201c;x-small&#x201d;"
                                            @click.stop="checkDeleteTag(tag.id)"
                                            >$oss-trash</v-icon
                                        >
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item key="accessRightTab" value="accessRightTab">
                <v-row
                    no-gutters
                    style="border-radius: 12px; background: #f8f8f8"
                    class="pa-2 fill-height"
                >
                    <v-col cols="8" class="title d-flex">
                        {{ accessRightPartition.name }}
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-end">
                        <v-text-field
                            v-model="newTags[accessRightPartition.key]"
                            append-inner-icon="$add"
                            label="Nom de la nouvelle cellule"
                            color="primary"
                            @click:append-inner="createTag(accessRightPartition)"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" class="my-3">
                        <div
                            class="list-group-item logItem px-2 py-1 mr-2 mt-1 d-flex"
                            v-for="tag in accessRightPartition.tags"
                            style="width: fit-content !important; float: left"
                            :key="tag.id"
                            @click.stop="editTag(tag)"
                        >
                            <span>{{ tag.name }}</span>
                            <div class="pl-2">
                                <v-icon
                                    dense
                                    size="&#x201c;x-small&#x201d;"
                                    @click.stop="checkDeleteTag(tag.id)"
                                    >$oss-trash</v-icon
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-window-item>
        </v-tabs-window>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @valid="deleteTag"
            :validLoading="deleteLoading"
            width="60vw"
        >
            <div class="text-center">
                <h4>Attention : cette étiquette est utilisée.</h4>
                <h4>&#xca;tes-vous sûr(e) de vouloir supprimer cette étiquette ?</h4>
            </div>
        </oss-dialog>
        <v-snackbar v-model="errorTag" :timeout="2000" location="end">
            Le tag {{ isExistingTagName }} existe déjà
            <template v-slot:actions>
                <v-btn @click="errorTag = false" variant="text"> Close </v-btn>
            </template>
        </v-snackbar>
        <TagEditionDialog
            v-model="showTagDialog"
            v-if="showTagDialog"
            :currentTag="currentTag"
            :companyId="companyId"
            :distribution="distribution"
            @upsertedTag="resetTag()"
        >
        </TagEditionDialog>
        <oss-dialog
            v-model="mergeDialog"
            v-if="mergeDialog"
            title="Fusionner"
            :actions="actions"
            min-width="600px"
        >
            <MergeTags
                :tagsToMerge="selectedTags"
                :companyId="companyId"
                :actions="actions"
                @tags-merged="afterTagsMerged()"
            />
        </oss-dialog>
        <oss-dialog
            v-model="partitionDialog"
            v-if="partitionDialog"
            @valid="updatePartition()"
            @close="selectedPartition = null"
            :validDisabled="!partitionValid"
            :validLoading="updatePartitionLoading"
            min-width="600px"
        >
            <v-form v-model="partitionValid" v-if="selectedPartition" class="mt-2">
                <v-row>
                    <v-col cols="12" class="d-flex justify-end">
                        <v-text-field-filled
                            v-model="selectedPartition.name"
                            outlined
                            label="Nom"
                            :rules="[(v) => !!v || $t('settings.itemRequired')]"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="d-flex justify-end">
                        <v-combobox-filled
                            v-model="selectedPartition.rules.rootAccountableAccounts"
                            label="Un de ces comptes racines"
                            multiple
                            outlined
                            dense
                            chips
                            deletable-chips
                            item-disabled
                            :rules="[rules.onlyNumbers]"
                            v-if="
                                selectedPartition.rules &&
                                selectedPartition.rules.rootAccountableAccounts
                            "
                        />
                    </v-col>
                </v-row>
            </v-form>
        </oss-dialog>
        <oss-dialog
            v-model="dialogCreatePartitionTag"
            v-if="dialogCreatePartitionTag"
            title="Ajouter une partition générique"
            @close="dialogCreatePartitionTag = false"
            @valid="
                createPartitionTag();
                dialogCreatePartitionTag = false;
            "
            :validDisabled="!partitionName"
            min-width="600px"
        >
            <v-row
                no-gutters
                class="pa-2 my-2 elevation-0"
                style="border-radius: 12px; background: #f8f8f8"
            >
                <v-col cols="12" class="pr-2 d-flex align-center">
                    <v-text-field
                        v-model="partitionName"
                        outlined
                        label="Nom de la partition"
                        hide-details
                        density="compact"
                    />
                </v-col>
            </v-row>
        </oss-dialog>
        <v-snackbar v-model="isErrorMessageTagToPartitionTag" color="error">
            {{ tagError }}
            <template v-slot:actions>
                <v-btn-icon
                    icon="$oss-close"
                    color="white"
                    size="small"
                    @click="isErrorMessageTagToPartitionTag = false"
                >
                </v-btn-icon>
            </template>
        </v-snackbar>
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Vue, Component, Watch, Model, Ref, toNative } from "vue-facing-decorator";
import { Apollo } from "../../decorators";
import draggable from "vuedraggable";
import _ from "lodash";

import PARTITION_TAGS_COMPANY from "../../graphql/tag/PartitionTagsCompany.gql";
// import PARTITION_TAGS_ACCOUNTING_FIRM from "../../graphql/tag/PartitionTagsAccountingFirm.gql"
import PARTITION_TAGS_SCOPING from "../../graphql/tag/PartitionTagsScoping.gql";

import CREATE_FREE_TAG from "../../graphql/tag/CreateTag.gql";
import CHECK_TAG_TO_PARTITION_TAG from "@/graphql/tag/CheckTagToPartitionTag.gql";
import UPDATE_TAG from "../../graphql/tag/UpdateTag.gql";
import DELETE_PARTITION from "../../graphql/tag/DeletePartitionTag.gql";
import UPDATE_PARTITION_TAG from "../../graphql/tag/UpdatePartitionTag.gql";
import DUPLICATE_PARTITION_TAG from "../../graphql/tag/DuplicatePartitionTag.gql";
import USED_TAGS from "../../graphql/tag/UsedTags.gql";
import DELETE_TAG from "../../graphql/tag/DeleteTag.gql";
import DELETE_UNUSED_TAGS from "../../graphql/tag/DeleteUnUsedTags.gql";

import { documentLogs } from "../../services/accountingItemServices";
import { truncate } from "../../services/stringServices";
import { createPartitionTag } from "../../services/tagServices";

import MergeTags from "./MergeTags.vue";
import { DialogAction } from "../../services/dialogAction";
import TagEditionDialog from "./TagEditionDialog.vue";

@Component({
    components: {
        draggable,
        MergeTags,
        TagEditionDialog,
    },
    emits: ["disable-merge-button"],
})
export class TagManager extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;
    @Ref() readonly refScope!: any;

    isErrorMessageTagToPartitionTag = false;
    tabStep = "tagTab";
    step = 0;

    search = "";

    tagError = "";

    selectedTags = [];
    mergeDialog = false;
    partitionDialog = false;

    partitionValid = true;
    selectedPartition = null;
    updatePartitionLoading = false;

    message = [
        "vue.draggable",
        "draggable",
        "component",
        "for",
        "vue.js 2.0",
        "based",
        "on",
        "Sortablejs",
    ];

    actions = {
        action: new DialogAction(),
    };

    editable = true;
    isDragging = false;
    delayedDragging = false;
    partitionName = "";
    isExistingTagName = "";
    // usedTags: any = []
    // usedTagsComputed = false

    accessRightPartition = {
        id: "",
        key: "AccessRight",
        type: "AccessRight",
        name: "",
        tags: [],
    };

    defaultAccessRightPartition = {
        id: "",
        key: "AccessRight",
        type: "AccessRight",
        name: "",
        tags: [],
    };

    get dragOptions() {
        return {
            animation: 0,
            group: "description",
            disabled: false,
            ghostClass: "ghost",
        };
    }

    newTags = {};

    errorTag = false;

    viewMode = 0;

    tags = [];

    tagTypes = [
        { text: "Tous", value: "Tous" },
        { text: "External", value: "External" },
        { text: "TagDistribution", value: "TagDistribution" },
    ];

    selectedTagType = "Tous";

    filteredTags = [];

    logs = [];

    scopeId_: string = "";

    dialogCreatePartitionTag: boolean = false;

    // resetScope: boolean = true

    beforeMount() {
        this.filterTags();
    }

    get scopeId() {
        if (this.scopeSync?.id && !this.scopeId_) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get companyId() {
        return this.$store?.state?.selected_company?.id
            ? this.$store.state.selected_company.id
            : null;
    }

    get accountingFirmId() {
        // Conditionner pour marcher seulement dans la GI
        if (!this.companyId) {
            return this.$store?.state?.user?.company?.id ? this.$store.state.user.company.id : null;
        }

        return null;
    }

    // get accountingFirmId() {
    //     console.log('store', this.$store)
    //     return this.$store.state.user
    // }

    get unclassedPartitionTag() {
        return this.partitionTags[0];
    }

    get classedPartitionTags() {
        if (this.search) {
            return this.partitionTags
                .filter((pt) => pt.name.toLowerCase().includes(this.search.toLowerCase()))
                .slice(1);
        }
        return this.partitionTags.slice(1);
    }

    truncateName(name) {
        return truncate(name, 10);
    }

    onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    }

    async createPartitionTag() {
        let newPartitionTag = null;

        if (this.companyId) {
            newPartitionTag = await createPartitionTag(
                this.companyId,
                null,
                this.partitionName,
                "Total",
            );
        } else {
            if (this.refScope) {
                await this.refScope.upsert();

                if (this.accountingFirmId && this.scopeId) {
                    newPartitionTag = await createPartitionTag(
                        null,
                        this.scopeId,
                        this.partitionName,
                        "AccountingFirm",
                    );
                }
            }
        }

        if (newPartitionTag?.id) {
            this.partitionTags.push({
                name: this.partitionName,
                id: newPartitionTag.id,
                key: newPartitionTag.id,
                tags: [],
                rules: {
                    rootAccountableAccounts: [],
                },
            });
            this.partitionName = "";
            this.scopeId = null;
        }
    }

    initLogs() {
        this.logs = documentLogs.map((dl) => ({
            id: "",
            primaryLog: dl,
            key: dl,
            name: this.$t("document.type." + dl),
            tags: [],
        }));
    }

    @Apollo({
        query() {
            return PARTITION_TAGS_COMPANY;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    let accessRightPartition = _.cloneDeep(this.defaultAccessRightPartition);
                    const partitionTags = [];

                    const tags =
                        data.tags && data.tags.length
                            ? data.tags.map((tag, index) => ({
                                  ...tag,
                                  order: index + 1,
                                  fixed: false,
                              }))
                            : [];

                    for (const pt of data.partitionTags) {
                        pt.key = pt.id;
                        if (pt.type !== "AccessRight") {
                            partitionTags.push(pt);
                        } else {
                            if (accessRightPartition.id) {
                                debugger;
                            }
                            accessRightPartition = pt;
                        }
                    }
                    this.initLogs();

                    for (const partition of partitionTags) {
                        let index = 1;
                        for (const tag of partition.tags) {
                            tag.order = index;
                            tag.fixed = false;
                            index++;
                        }
                        if (!partition.rules) {
                            partition.rules = {};
                        }
                        if (!partition.rules.rootAccountableAccounts) {
                            partition.rules.rootAccountableAccounts = [];
                        }
                    }

                    const withoutIdPartitionTag = {
                        id: "WithoutId",
                        key: "WithoutId",
                        name: "Non classé",
                        tags: [],
                    };
                    partitionTags.unshift(withoutIdPartitionTag);

                    // Handle tags for PARTITION_TAGS_COMPANY
                    if (tags.length) {
                        for (const tag of tags) {
                            if (tag.primaryLog) {
                                let logPartition = this.logs.find(
                                    (l) => l.primaryLog === tag.primaryLog,
                                );
                                if (!logPartition) {
                                    logPartition = {
                                        id: "",
                                        primaryLog: tag.primaryLog,
                                        key: tag.primaryLog,
                                        name: this.$t("document.type." + tag.primaryLog),
                                        tags: [],
                                    };
                                    this.logs.push(logPartition);
                                }
                                logPartition.tags.push(tag);
                            } else if (!tag.partitionTag) {
                                withoutIdPartitionTag.tags.push(tag);
                            }
                        }
                    }

                    const newTags = {};
                    partitionTags.forEach((partition) => {
                        newTags[partition.key] = "";
                    });
                    this.logs.forEach((partition) => {
                        newTags[partition.key] = "";
                    });
                    newTags[accessRightPartition.key] = "";

                    this.partitionTags = partitionTags;
                    this.accessRightPartition = accessRightPartition;
                    this.newTags = newTags;
                    this.tags = data.tags || [];
                } else {
                    this.partitionTags = [];
                    this.logs = [];
                    this.newTags = {};
                }
            }
        },
    })
    partitionTags = [];

    @Apollo({
        query() {
            return PARTITION_TAGS_SCOPING;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    let accessRightPartition = _.cloneDeep(this.defaultAccessRightPartition);
                    const scopingPartitionTags = [];

                    if (data.partitionTagsScoping && data.partitionTagsScoping.length) {
                        const seenKeys = new Set();
                        for (const pt of data.partitionTagsScoping) {
                            pt.key = pt.id;
                            if (!seenKeys.has(pt.key)) {
                                seenKeys.add(pt.key);
                                if (pt.type !== "AccessRight") {
                                    scopingPartitionTags.push(pt);
                                } else {
                                    if (accessRightPartition.id) {
                                        debugger;
                                    }
                                    accessRightPartition = pt;
                                }
                            }
                        }
                        // this.initLogs()

                        for (const partition of scopingPartitionTags) {
                            // let index = 1
                            for (const tag of partition.tags) {
                                // tag.order = index
                                // tag.fixed = false
                                // index++
                            }
                            if (!partition.rules) {
                                partition.rules = {};
                            }
                            if (!partition.rules.rootAccountableAccounts) {
                                partition.rules.rootAccountableAccounts = [];
                            }
                        }
                    }
                    // const withoutIdPartitionTag = {
                    //     id: "WithoutId",
                    //     key: "WithoutId",
                    //     name: "Non classé",
                    //     tags: []
                    // }
                    // scopingPartitionTags.unshift(withoutIdPartitionTag)

                    // const newTags = {}
                    // scopingPartitionTags.forEach(partition => {
                    //     newTags[partition.key] = ""
                    // })
                    // this.logs.forEach(partition => {
                    //     newTags[partition.key] = ""
                    // })
                    // newTags[accessRightPartition.key] = ""
                    debugger;

                    this.scopingPartitionTags = scopingPartitionTags;
                    // this.accessRightPartition = accessRightPartition
                    // this.newTags = newTags
                    // this.tags = data.tags || []
                } else {
                    this.scopingPartitionTags = [];
                    // this.logs = []
                    // this.newTags = {}
                }
            }
        },
    })
    scopingPartitionTags = [];

    @Apollo({
        query: USED_TAGS,
        variables() {
            return {
                companyId: this.companyId,
                mode: "all",
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.usedTags?.tags) {
                    this.usedTags = data.usedTags.tags;
                }
            }
        },
    })
    usedTags = [];

    @Watch("isDragging")
    isDraggingWatch() {
        if (this.isDragging) {
            this.delayedDragging = true;
            return;
        }
        this.$nextTick(() => {
            this.delayedDragging = false;
        });
    }

    isExistingTag(key) {
        if (this.newTags[key]) {
            const name = this.newTags[key].toLowerCase();
            const tags = this.partitionTags.flatMap((x) => x.tags);
            return !!tags.filter((x) => x.name.toLowerCase() === name).length;
        }
        return true;
    }

    async createTag(partition) {
        const key = partition.key;
        if (!key) {
            debugger; // git-ignore
            return;
        }
        if (!this.newTags[key]) {
            return;
        }
        let partitionId = partition.id;
        if (!this.isExistingTag(key)) {
            if (!partition.id) {
                if (partition.type === "AccessRight") {
                    const accessRightPartition = await createPartitionTag(
                        this.companyId,
                        null,
                        "Droit d'accès",
                        partition.type,
                    );
                    partitionId = accessRightPartition.id;
                    this.accessRightPartition.id = accessRightPartition.id;
                    this.accessRightPartition.key = accessRightPartition.id;
                } else if (!partition.primaryLog) {
                    debugger; // git-ignore
                    return;
                }
            }
            const result = await this.$apollo.mutate({
                mutation: CREATE_FREE_TAG,
                variables: {
                    name: this.newTags[key],
                    primaryLog: partition.primaryLog || undefined,
                    partitionConnect:
                        !partitionId || partitionId === "WithoutId"
                            ? undefined
                            : { connect: { id: partitionId } },
                    companyId: partition?.accountingFirm?.id
                        ? this.accountingFirmId
                        : this.companyId
                          ? this.companyId
                          : this.accountingFirmId
                            ? this.accountingFirmId
                            : null,
                },
            });
            const createdTag = result.data.createTag;
            const addNewPartitionTag = this.partitionTags.find((x) => x.key === key);
            if (addNewPartitionTag) {
                addNewPartitionTag.tags.push(createdTag);
            } else if (this.accessRightPartition?.key === key) {
                this.accessRightPartition.tags.push(createdTag);
            } else if (createdTag.primaryLog) {
                const log = this.logs.find((l) => l.primaryLog === createdTag.primaryLog);
                if (log) {
                    log.tags.push(createdTag);
                } else {
                    debugger; // git-ignores
                }
            }
        } else {
            this.errorTag = true;
            this.isExistingTagName = this.newTags[key];
        }
        this.newTags[key] = "";
    }

    async checkIfTagCanMoveToPartitionTag(tagId: string, partitionTagId: string) {
        const response = await this.$apollo.query({
            query: CHECK_TAG_TO_PARTITION_TAG,
            variables: {
                tagId: tagId,
                partitionTagId: partitionTagId,
                companyId: this.companyId,
            },
        });
        if (!response.data.checkTagCanGoToPartitionTag.success) {
            this.tagError = response.data.checkTagCanGoToPartitionTag.error;
            this.isErrorMessageTagToPartitionTag = true;
        }
        return response.data.checkTagCanGoToPartitionTag.success;
    }

    async updateTag(item, partitionId) {
        console.log("partitionId", partitionId);
        const tagId = item?.added?.element ? item.added.element.id : item.id ? item.id : "";

        if (tagId && (await this.checkIfTagCanMoveToPartitionTag(tagId, partitionId))) {
            await this.$apollo.mutate({
                mutation: UPDATE_TAG,
                variables: {
                    id: tagId,
                    partitionConnect:
                        partitionId === "WithoutId"
                            ? { disconnect: true }
                            : { connect: { id: partitionId } },
                },
            });
        }
        this.refresh();
    }

    async deletePartition(partitionId) {
        await this.$apollo.mutate({
            mutation: DELETE_PARTITION,
            variables: {
                id: partitionId,
            },
        });
        const deletedPartition = this.partitionTags.find((x) => x.id === partitionId);
        const withoutPartition = this.partitionTags.find((x) => x.id === "WithoutId");
        withoutPartition.tags.push(...deletedPartition.tags);
        this.partitionTags = this.partitionTags.filter((x) => x.id !== partitionId);
    }

    editPartition(partition) {
        this.selectedPartition = JSON.parse(JSON.stringify(partition));
        this.partitionDialog = true;
        // this.step = 1
    }

    async updatePartition() {
        if (this.selectedPartition && this.selectedPartition.id) {
            this.updatePartitionLoading = false;
            await this.$apollo.mutate({
                mutation: UPDATE_PARTITION_TAG,
                variables: {
                    id: this.selectedPartition.id,
                    name: this.selectedPartition.name,
                    rules: this.selectedPartition.rules,
                },
            });
            const partition = this.partitionTags.find((pt) => pt.id === this.selectedPartition.id);
            if (partition) {
                partition.name = this.selectedPartition.name;
                partition.rules = this.selectedPartition.rules;
            }
            this.step = 0;
            this.updatePartitionLoading = false;
        }
    }

    async duplicatePartitionAccountingFirm(partition) {
        if (partition && partition.id) {
            const duplicatedPartitionTag = await this.$apollo.mutate({
                mutation: DUPLICATE_PARTITION_TAG,
                variables: {
                    companyId: this.companyId,
                    partitionTagId: partition.id,
                },
            });
            // this.$apollo.queries.scopingPartitionTags.refetch()
            this.refresh();
        }
    }

    tagDeletable(tagId) {
        return !this.usedTags.find((t) => t.id === tagId);
    }

    deleteDialog: boolean = false;
    deleteLoading: boolean = false;
    toDeleteTagId = "";

    disabledDeleteTag(partitionTag) {
        if (partitionTag?.type === "Building") {
            return true;
        }
        return false;
    }

    async checkDeleteTag(tagId) {
        this.toDeleteTagId = tagId;
        if (this.tagDeletable(tagId)) {
            await this.deleteTag();
        } else {
            this.toDeleteTagId = tagId;
            this.deleteDialog = true;
            this.deleteLoading = false;
        }
    }

    async deleteTag() {
        if (this.toDeleteTagId) {
            this.deleteLoading = true;
            const deletedTag = await this.$apollo.mutate({
                mutation: DELETE_TAG,
                variables: {
                    tagId: this.toDeleteTagId,
                },
            });

            if (deletedTag.data.deleteTag) {
                this.tags = this.tags.filter((t) => t.id !== this.toDeleteTagId);
            }

            this.deleteLoading = false;
            this.deleteDialog = false;
            this.refresh();
        }
        // delete the tag in partitionTag
        // find the modified partition ID
        // find the deleted tag ID through partitionTags.find (the index is still in the list)
        // filter the list to delete the deleted tag
        // this.partitionTags[index].tags = this.partitionTags[index].tags.filter(t => t.id !== tagId);
    }

    async deleteSelectedTags() {
        if (this.selectedTags.length) {
            for (const selectedTag of this.selectedTags) {
                const deletedTag = await this.checkDeleteTag(selectedTag.id);
                if (deletedTag !== undefined) {
                    this.tags = this.tags.filter((t) => t.id !== selectedTag.id);
                }
                this.refresh();
            }
        }

        this.selectedTags = [];
    }

    mergeSelectedTags() {
        this.mergeDialog = true;
    }

    get mergeDisabled() {
        if (this.hasTagDistribution) {
            return true;
        }

        if (this.selectedTags.length < 2) {
            return true;
        }

        return false;
    }

    get hasTagDistribution() {
        if (this.selectedTags.some((tag) => tag.type === "TagDistribution")) {
            return true;
        }
        return false;
    }

    showTagDialog: boolean = false;
    distribution: boolean = false;
    companyScopeDialog: boolean = false;
    tagLoading: boolean = false;

    currentTag = null;

    defaultCurrentTag = {
        id: "",
        type: "TagDistribution",
        percentageTags: [],
        percentages: [],
    };

    initializeCurrentTag() {
        this.currentTag = JSON.parse(JSON.stringify(this.defaultCurrentTag));
    }

    openNewTagDistributionDialog(partition) {
        this.initializeCurrentTag();
        this.currentTag.partitionTag = partition;
        this.currentTag.percentageTags = this.currentTag.partitionTag.tags.filter(
            (t) => t.type !== "TagDistribution",
        );
        this.currentTag.percentages = new Array(this.currentTag.percentageTags.length).fill(0.0);

        this.tagLoading = false;
        this.distribution = true;
        this.showTagDialog = true;
    }

    editTag(tag) {
        if (tag) {
            this.currentTag = JSON.parse(JSON.stringify(tag));
            const partitionTag = this.partitionTags.find((pt) =>
                pt.tags.find((t) => t?.id === this.currentTag.id),
            );
            if (partitionTag?.type === "Building") {
                return;
            }
            this.currentTag.partitionTag = partitionTag;
            if (this.currentTag.type === "TagDistribution") {
                this.currentTag.percentageTags = this.currentTag.partitionTag.tags.filter(
                    (t) => t.type !== "TagDistribution",
                );
                this.currentTag.percentages = new Array(this.currentTag.percentageTags.length).fill(
                    0.0,
                );
                for (let index = 0; index < tag.percentageTags.length; index++) {
                    const percentageTag = tag.percentageTags[index];
                    const foldedIndex = this.currentTag.percentageTags.findIndex(
                        (t) => t.id === percentageTag.id,
                    );
                    if (foldedIndex >= 0 && foldedIndex < this.currentTag.percentageTags.length) {
                        this.currentTag.percentages[foldedIndex] = tag.percentages[index] * 100;
                    }
                }
            }
            this.tagLoading = false;
            this.showTagDialog = true;
            this.distribution = false;
        }
    }

    resetTag() {
        this.currentTag = null;
        this.distribution = false;
        this.refresh();
    }

    get percentageTotal() {
        let total = 0;
        for (const percentage of this.currentTag.percentages) {
            if (!percentage) {
                continue;
            }
            total += percentage;
        }
        return total;
    }

    refresh() {
        console.log("tagManager refresh");
        if (this.$apollo.queries.usedTags?.refetch) {
            this.$apollo.queries.usedTags.refetch();
            this.isErrorMessageTagToPartitionTag = this.isErrorMessageTagToPartitionTag;
        } else {
            debugger;
        }
        if (this.$apollo.queries.partitionTags?.refetch) {
            this.$apollo.queries.partitionTags.refetch();
            this.isErrorMessageTagToPartitionTag = this.isErrorMessageTagToPartitionTag;
        } else {
            debugger;
        }
    }

    async deleteUnUsedTags() {
        await this.$apollo.mutate({
            mutation: DELETE_UNUSED_TAGS,
            variables: {
                companyId: this.companyId,
            },
        });
        this.refresh();
    }
    //
    //
    //

    get rules() {
        return {
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
            notEmptyAutocomplete: (value) => {
                if (value instanceof Array && value.length == 0) {
                    return "Il faut remplir une de ces conditions";
                }
                return !!value || "Il faut remplir une de ces conditions";
            },
            onlyNumbers: (value) => {
                for (const v of value) {
                    if (v.startsWith("0") || !/^[0-9]+$/.test(v)) {
                        return "Seuls des comptes racines sont acceptés";
                    }
                }
                return true;
            },
        };
    }

    isSelectedTag(tag) {
        const isSelected = this.selectedTags.find((t) => t.id === tag.id);
        return isSelected;
    }

    selectTag(tag) {
        const index = this.selectedTags.findIndex((t) => t.id === tag.id);

        if (index !== -1) {
            this.selectedTags.splice(index, 1);
        } else {
            this.selectedTags.push(tag);
        }
    }

    afterTagsMerged() {
        this.selectedTags = [];
        this.mergeDialog = false;
        this.refresh();
        this.$apollo.queries.partitionTags.refetch();
        this.$apollo.queries.tags.refetch();
    }

    @Watch("selectedTagType")
    @Watch("tags")
    filterTags() {
        if (this.selectedTagType === "Tous") {
            this.filteredTags = this.tags;
        } else {
            this.filteredTags = this.tags.filter((tag) => tag.type === this.selectedTagType);
        }
    }

    selectAllTags() {
        if (this.filteredTags?.length) {
            this.selectedTags.push(...this.filteredTags);
        }
    }

    diselectAllTags() {
        this.$emit("disable-merge-button", true);
        this.selectedTags = [];
    }

    getTargets(scope) {
        let targets = "Pour ";
        if (scope.accountingCompany) {
            if (scope.clients.length) {
                targets +=
                    scope.clients.length.toString() +
                    " client(s) : " +
                    scope.clients
                        .slice(0, 5)
                        .map((x) => x.name)
                        .join(", ") +
                    (scope.clients.length > 5 ? ", ..." : "");
            } else if (scope.taxSystems) {
                targets += " les " + scope.taxSystems + " de mon cabinet";
            } else if (scope.activities && scope.activities.length) {
                targets +=
                    scope.activities.length.toString() +
                    " activité(s) : " +
                    scope.activities
                        .slice(0, 5)
                        .map((x) => x.name)
                        .join(", ") +
                    (scope.activities.length > 5 ? ", ..." : "") +
                    " de mon cabinet";
            } else {
                targets += "tous les clients de mon cabinet";
            }
        } else if (scope.taxSystems) {
            targets += " les " + scope.taxSystems + " de tous les cabinets";
        } else if (scope.activities && scope.activities.length) {
            targets +=
                scope.activities.length.toString() +
                " activité(s) : " +
                scope.activities
                    .slice(0, 5)
                    .map((x) => x.name)
                    .join(", ") +
                (scope.activities.length > 5 ? ", ..." : "") +
                " de tous les cabinets";
        } else {
            targets += "tous les clients de tous les cabinets";
        }
        return targets;
    }

    isPartitionUsed(partitionId) {
        const isUsed = this.partitionTags.find((pt) => pt?.parent?.id === partitionId);
        return isUsed;
    }
}

export default toNative(TagManager);
</script>

<style>
.flip-list-move {
    transition: transform 0.5s;
}

.no-move {
    transition: transform 0s;
}

.ghost {
    background: #c8ebfb;
}

.list-group {
    min-height: 20px;
    min-width: 100%;
}

.list-group-item {
    cursor: move;
}

.list-group-item i {
    cursor: pointer;
}

.item {
    background: #d1e5f9;
    border-radius: 4px;
}

.logItem {
    background: #e1d5fa;
    border-radius: 4px;
}
</style>
